var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPharmTrixPill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M13.9653 47.607C9.50453 43.1458 6.9987 37.0953 6.99902 30.7865C6.99935 24.4777 9.50582 18.4275 13.967 13.9667C18.4282 9.50599 24.4787 7.00016 30.7875 7.00049C37.0963 7.00082 43.1465 9.50728 47.6073 13.9685L70.0318 36.393C72.2775 38.5933 74.0646 41.217 75.29 44.1123C76.5154 47.0076 77.1546 50.1171 77.1707 53.261C77.1869 56.4049 76.5796 59.5208 75.3839 62.4285C74.1883 65.3363 72.4281 67.9781 70.2052 70.2014C67.9822 72.4246 65.3405 74.185 62.4329 75.381C59.5253 76.5769 56.4094 77.1845 53.2655 77.1687C50.1216 77.1529 47.012 76.514 44.1166 75.2889C41.2212 74.0639 38.5973 72.2769 36.3968 70.0315L13.9653 47.607Z",
    fill: "#308ED7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.325 60.9665L22.9395 56.5775L24.672 56.245H24.6755L24.7245 56.231C24.7758 56.2216 24.861 56.2018 24.98 56.1715C25.225 56.1155 25.5936 56.0093 26.086 55.853C27.0695 55.538 28.5255 55.0025 30.321 54.138C33.905 52.4125 38.8505 49.364 44.1075 44.107C49.3575 38.8535 52.4095 33.9045 54.1385 30.317C55.003 28.525 55.5385 27.0725 55.8535 26.0855C55.9977 25.6369 56.1238 25.1827 56.2315 24.724L56.242 24.675L56.578 22.939L60.9635 27.3245L60.8515 27.685C60.3036 29.3666 59.6405 31.0085 58.867 32.599C56.907 36.666 53.5295 42.1085 47.8175 47.8205C42.109 53.529 36.663 56.91 32.5995 58.8665C30.8954 59.6953 29.1324 60.3972 27.325 60.9665Z",
    fill: "url(#paint0_linear_181_647)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_181_647",
    x1: 22.9395,
    y1: 41.9527,
    x2: 60.9635,
    y2: 41.9527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18487F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#27C4F4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPharmTrixPill);
export default __webpack_public_path__ + "static/media/Pharm Trix Pill.f8c7850bcbc75f7440e5682cdfa61126.svg";
export { ForwardRef as ReactComponent };